module.exports = __webpack_public_path__ + "d93eec02edbb5f9a153e8948c0bdb223.pdf";